var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LogList',{ref:"logList",attrs:{"isModal":false,"pagingData":_vm.paging,"reqPath":'admin/general-log',"filterValues":_vm.filterValues,"filters":_vm.tableFilterConfig,"loadUsers":true},on:{"clearFilters":_vm.clearFilters}})}
var staticRenderFns = []

export { render, staticRenderFns }